import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter({ onOpenPolicy }) {
  return (
    <footer className="footer">
      <div className="mx-auto max-w-6xl px-6 flex items-center justify-between">
        <div className="subtle">© {new Date().getFullYear()} AI Music Maker</div>
        <nav className="flex items-center gap-3">
          <button className="btn-outline" onClick={() => onOpenPolicy && onOpenPolicy('pricing')}>Pricing</button>
          <Link className="btn-outline" to="/privacy">Privacy</Link>
          <Link className="btn-outline" to="/terms">Terms</Link>
          <Link className="btn-outline" to="/refund">Refund</Link>
        </nav>
      </div>
    </footer>
  );
}

